const layouts = ['web.layout.grid', 'web.layout.grid-item', 'web.layout.stack', 'web.layout.surface'] as const

const screen = (path: string, label: string, capabilities: readonly string[]) => ({
  path,
  label,
  allowedCapabilities: [...new Set([...layouts, ...capabilities])],
})

export const CLIENTPORTAL_SCREEN_V2 = Object.freeze({
  'clientportal.events': screen('/events', 'Events', [
    'clientportal.events.header',
    'clientportal.events.live-now',
    'clientportal.events.list',
  ]),
  'clientportal.events.live': screen('/events/live', 'Live events', ['clientportal.events.header', 'clientportal.events.directory']),
  'clientportal.events.upcoming': screen('/events/upcoming', 'Upcoming events', [
    'clientportal.events.header',
    'clientportal.events.directory',
  ]),
  'clientportal.events.past': screen('/events/past', 'Past events', ['clientportal.events.header', 'clientportal.events.directory']),
  'clientportal.events.detail': screen('/events/:eventId', 'Event', ['clientportal.events.detail']),
})
